import React, { ReactNode } from 'react';

import CurrencyFormatter from '@apigrowfinance/pbolt-currency-formatter';
import { FormattedMessage } from 'react-intl';

import CurrentBalance from '@components/overviewPanels/currentBalance/CurrentBalance';
import { useAccount } from '@contexts/AccountProvider';

const CurrentBalanceContainer = () => {
    const {
        account,
        program,
        error,
        isLoading: isLoadingAccount,
    } = useAccount();

    const isErrorAccount = error?.programIsError || error?.accountIsError;
    const currencyCode = program?.currency_numeric_code;
    let displayBalance: ReactNode;
    let title = (
        <FormattedMessage
            id="CurrentBalance.CurrentBalance"
            defaultMessage="Current balance"
        />
    );
    if (program?.type === 'CREDITO') {
        const positivelyCreditedAccount =
            account?.available_limit > account?.total_credit_limit;
        if (positivelyCreditedAccount) {
            displayBalance = (
                <CurrencyFormatter
                    amount={
                        account?.available_limit - account?.total_credit_limit
                    }
                    currency={currencyCode}
                    symbol="positive"
                />
            );
        } else {
            displayBalance = (
                <CurrencyFormatter
                    amount={
                        account?.total_credit_limit - account?.available_limit
                    }
                    currency={currencyCode}
                />
            );
            title = (
                <FormattedMessage
                    id="CurrentBalance.Due"
                    defaultMessage="Total due"
                />
            );
        }
    } else {
        displayBalance = (
            <CurrencyFormatter
                amount={account?.available_limit}
                currency={currencyCode}
            />
        );
    }

    return (
        <CurrentBalance
            title={title}
            currentBalance={displayBalance}
            isLoading={isLoadingAccount}
            isError={isErrorAccount}
        />
    );
};

export default CurrentBalanceContainer;
